export function toTitleCaseName(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\b([a-z])/g, (match) => match.toUpperCase());
}

export function formatDegree(value) {
  const text = String(value || "").trim();
  if (!text || text === "-") return "";
  return text.endsWith(".") ? text : `${text}.`;
}

export function formatPersonName(item, nameKeys = ["nama_lengkap", "personal_name", "entity_name", "nama"]) {
  if (typeof item === "string") {
    return toTitleCaseName(item);
  }

  const source = nameKeys
    .map((key) => item?.[key])
    .find((value) => String(value || "").trim());
  const name = toTitleCaseName(source);
  const fullName = [formatDegree(item?.gelar_depan), name].filter(Boolean).join(" ");

  return [fullName, formatDegree(item?.gelar_belakang)].filter(Boolean).join(", ");
}
